/** Campos do usuário logado que decidem o acesso ao Agente de Estação. */
export interface UsuarioAcessoAgente {
  role?: string;
  permissions?: string[];
  representanteId?: number | null;
}

/** Limites do pacote de instalação por perfil. Espelham LIMITES_PACOTE_* do backend. */
export interface LimitesPacote {
  usos: number;
  validadeHoras: number;
}

export const LIMITES_PACOTE_ADMIN: LimitesPacote = { usos: 50, validadeHoras: 24 };
export const LIMITES_PACOTE_REPRESENTANTE: LimitesPacote = { usos: 20, validadeHoras: 8 };

/** Admin e supervisor: acesso total ao painel. */
export function ehAdminOuSupervisor(user: UsuarioAcessoAgente | null | undefined): boolean {
  return user?.role === 'ADMIN' || !!user?.permissions?.includes('SUPERVISOR');
}

/** Representante: usuário com representanteId definido (inteiro positivo). */
export function ehRepresentante(user: UsuarioAcessoAgente | null | undefined): boolean {
  const id = user?.representanteId;
  return typeof id === 'number' && Number.isInteger(id) && id > 0;
}

/** Quem vê e abre /agente: admin, supervisor ou representante. Os demais são redirecionados. */
export function podeAcessarAgenteEstacao(user: UsuarioAcessoAgente | null | undefined): boolean {
  return ehAdminOuSupervisor(user) || ehRepresentante(user);
}

/** Limites do pacote para o perfil do usuário. */
export function limitesPacoteDoUsuario(user: UsuarioAcessoAgente | null | undefined): LimitesPacote {
  return ehAdminOuSupervisor(user) ? LIMITES_PACOTE_ADMIN : LIMITES_PACOTE_REPRESENTANTE;
}

/** Mensagem clara para 403/404 do backend nas telas do agente; nos demais casos, a mensagem padrão. */
export function mensagemDeAcesso(status: number | undefined, padrao: string): string {
  if (status === 403) return 'Você não tem permissão para esta ação. Fale com o administrador.';
  if (status === 404) return 'Não encontrado para o seu usuário. Confira o cliente selecionado.';
  return padrao;
}

/** Regra de visibilidade de um item do menu lateral. */
export function itemMenuVisivel(
  item: { path?: string; adminOnly?: boolean; representanteOk?: boolean },
  user: UsuarioAcessoAgente | null | undefined,
): boolean {
  if (item.representanteOk) return podeAcessarAgenteEstacao(user);
  if (item.adminOnly) return user?.role === 'ADMIN';
  return true;
}
